export const noBatchRowOrFirstRowInBatch = row => {
  const { batch, sequenceNumber } = row;
  return !batch || (batch && sequenceNumber === 1);
};

export default {};
